import { validateResponse } from "../../../../response.js";
import { authHeader, acceptJson } from "../../../../shared.js";
import { prescriptionsListSpec } from "./specs.js";
async function list(apiUrl, accessToken, request) {
  return validateResponse(
    prescriptionsListSpec,
    await fetch(
      `${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/prescriptions`,
      {
        method: "GET",
        headers: {
          ...acceptJson,
          ...authHeader(accessToken)
        }
      }
    )
  );
}
export {
  list
};
//# sourceMappingURL=list.js.map
